import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "output1";
const idNext = "output2";

const next = `
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - parameter: weapon
        choices:
          - choice: sword
          - choice: dagger
          - choice: axe
          - choice: mace
          - choice: spear
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
      - output parameter: outcome
        default value: good
`;

const prev = `
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - parameter: weapon
        choices:
          - choice: sword
          - choice: dagger
          - choice: axe
          - choice: mace
          - choice: spear
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake

`;

function ManualOutput1({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("add_output_parameter") && (
        <div className={`${styles["container"]} ${styles["container-out1"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-2" className={`${styles["container__text"]}`}>
            <p>
              Create an output parameter and name it <b>outcome</b>. Set its default value to{" "}
              <b>good</b>.
            </p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-2"
            end="add_output_parameter"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-out1"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Output parameters represent the expected result of a test. Because they don't contain
              choices, they won't increase the size of your generated test suite! Instead, their
              values are set dynamically using assignment expressions.
            </p>
            <p>Note: Unlike regular parameters, output parameters cannot be global.</p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Start fresh!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateOutput1 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resOut, msg: msgOut } = tutorialUtils.validateOutput(
      root,
      "root→[function]→simple→[parameter]→outcome",
      "good",
    );

    if (!resOut) {
      setMessage(msgOut);
      return false;
    }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualOutput1;
